import { useLanguage } from "../i18n/LanguageContext";
import { Building2, Gift, MessageSquare, FlaskConical } from "lucide-react";
import { SEO } from "../components/SEO";

const icons = {
  corporations: Building2,
  free: Gift,
  feedback: MessageSquare,
  testing: FlaskConical
};

export const WhyOpen = () => {
  const { t, language } = useLanguage();

  const sections = ["corporations", "free", "feedback", "testing"];

  return (
    <div className="min-h-screen pt-24 pb-16">
      <SEO page="whyOpen" />
      {/* Header */}
      <section className="px-4 sm:px-6 mb-12">
        <div className="max-w-3xl mx-auto text-center">
          <div className="decorative-line mb-4" />
          <h1 
            data-testid="why-open-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium text-[#2C3329] mb-4 animate-fade-in-up"
          >
            {t.whyOpen.title}
          </h1>
          <p className="text-lg text-[#6B7266] animate-fade-in-up animation-delay-200">
            {t.whyOpen.subtitle}
          </p>
        </div>
      </section>

      {/* Content Sections */}
      <section className="px-4 sm:px-6 mb-12">
        <div className="max-w-4xl mx-auto space-y-5">
          {sections.map((section, index) => {
            const Icon = icons[section];
            return (
              <div 
                key={section}
                data-testid={`why-open-section-${section}`}
                className="premium-card p-8 sm:p-10 rounded-xl animate-fade-in-up"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className={`flex ${language === 'he' ? 'flex-row' : 'flex-row'} items-start gap-6`}>
                  <div className="shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br from-[#C47F64]/10 to-[#C47F64]/5 flex items-center justify-center">
                    <Icon className="w-7 h-7 text-[#C47F64]" />
                  </div>
                  <div className="flex-1">
                    <h2 className="font-serif text-xl sm:text-2xl mb-4 text-[#2C3329]">
                      {t.whyOpen.sections[section].title}
                    </h2>
                    <p className="text-[#6B7266] leading-relaxed">
                      {t.whyOpen.sections[section].content}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Final Statement */}
      <section className="px-4 sm:px-6 py-12 section-warm">
        <div className="max-w-3xl mx-auto text-center">
          <div className="decorative-line mb-6" />
          <blockquote className="font-serif text-xl sm:text-2xl lg:text-3xl text-[#2C3329] leading-relaxed">
            "{t.whyOpen.statement}"
          </blockquote>
        </div>
      </section>
    </div>
  );
};

export default WhyOpen;
